'use client'

import { getUserOrders } from '@/eshop/queries'
import { hydrateResult } from '@/eshop/utils/client'
import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import Pagination from '../Pagination'
import Loader from '../Loader'
import UserOrder from './UserOrder'
import { useSearchParams } from 'next/navigation'
import { useTranslation } from 'react-i18next'

export default function UserOrders() {
    const { t } = useTranslation()
    const [k2Page, setK2Page] = useState<string | null>(null)
    const [page, setPage] = useState(1)
    const searchParams = useSearchParams()

    const openOrder = searchParams.get('openOrder')

    const { data, isFetching, isFetched } = useQuery({
        queryKey: ['userorders', k2Page],
        queryFn: () => getUserOrders()(k2Page, 20).toPromise(),
    })

    const dataResult = useMemo(() => hydrateResult(data), [data])
    const hasOrders = useMemo(
        () =>
            dataResult?.match({
                Ok: (o) => !!o?.orders?.records && o.orders.records.length > 0,
                Error: () => false,
            }) || false,
        [dataResult]
    )

    return (
        <div className="px-2 desktop:px-10">
            {!isFetching && !hasOrders && (
                <div className="text-center">
                    {t('eshop.usersettings.noOrders')}
                </div>
            )}
            <Loader isLoading={isFetching && !isFetched}>
                <>
                    {dataResult?.match({
                        Ok: (r) => (
                            <div className="flex flex-col gap-16">
                                {r.orders?.records?.map((o) => {
                                    return (
                                        <UserOrder
                                            isOpen={
                                                !!openOrder &&
                                                openOrder === o?.RID
                                            }
                                            key={o?.RID}
                                            order={o!}
                                            showDetail
                                        />
                                    )
                                })}
                            </div>
                        ),
                        Error: () => <div>{t('eshop.orders.dataError')}</div>,
                    })}
                    {isFetched && hasOrders && (
                        <Pagination
                            current={page}
                            hideNumbers
                            total={
                                dataResult?.match({
                                    Ok: (r) =>
                                        r.orders.nextPage ? page + 1 : page,
                                    Error: () => page,
                                }) || page
                            }
                            onPageChange={(newPage) => {
                                dataResult?.match({
                                    Ok: (r) => {
                                        if (
                                            newPage > page &&
                                            !r.orders.nextPage
                                        ) {
                                            return
                                        }
                                        setK2Page(
                                            newPage < page
                                                ? r.orders.previousPage || null
                                                : r.orders.nextPage || null
                                        )
                                        setPage(newPage)
                                    },
                                    Error: () => {
                                        setPage(1)
                                        setK2Page(null)
                                    },
                                })
                            }}
                        />
                    )}
                </>
            </Loader>
        </div>
    )
}
